/** Длина стандартного российского телефона */
export var RUSSIAN_PHONE_LENGTH = 11;

/** Дефолтный шаблон форматирования телефона */
export var DEFAULT_PHONE_TEMPLATE = '$1 $2 $3-$4-$5';